import React from 'react'
import PropTypes from 'prop-types'
import ListEpisode from './ListEpisode'

const ChannelEpisodes = (props) => {

  let epList = props.episodes.map(({ id, title, published, itunes, enclosures, links }) => {
    return (
      <div className='col mb-4' key={id}>
        <ListEpisode
          title={title}
          subtitle={itunes.subtitle}
          summary={itunes.summary}
          image={itunes.image}
          meta={{
            duration: itunes.duration,
            authors: itunes.authors,
            published: published
          }}
          link={links[0]}
          enclosures={enclosures}
        />
      </div>
    )
  })

  return (
    <div className='row row-cols-1'>
      {epList}
    </div>
  )
}

ChannelEpisodes.propTypes = {
  episodes: PropTypes.array.isRequired
}
export default ChannelEpisodes
